<template>
    <div class="clientDetail">
      <!--navBar-->
      <navBar></navBar>
      <!--中间内容部分-->
      <div class="main">
        <div class="mainContainer">
          <div class="nav_detail">
            <span class="nav_back" @click="goBack">案例中心</span> > <span>都邦保险</span>
          </div>
          <div class="flex_between">
            <div class="item_left">
              <div class="icon"><i></i></div>
              <p class="title">都邦保险</p>
              <div class="intro">
                <div>客户简介</div>
                <p>都邦保险成立于2005年，旗下拥有33家分公司和400多家分支机构，形成了覆盖全国的机构服务网络。都邦保险坚持把服务作为公司发展的生命线，以完善服务硬件设施配置、建设高素质的客户服务队伍、建立全国通赔网络系统和推广亲情特色化客户服务举措为重点，着力打造一流服务品牌，赢得了广大客户的广泛赞誉。</p>
              </div>
              <div class="products">
                <div>使用产品</div>
                <p @click="goProduct('/solution3')">一物一码品牌防伪</p>
                <p @click="goProduct('/product1')">漏洞扫描</p>
              </div>
            </div>
            <div class="item_right">
              <div class="title">
                <i></i>业务背景
              </div>
              <p>骗保一直是让保险业头疼的问题，在现今这个以诚信编织的社会里，从道德层面上约束人们的行为很重要，但有效的利用科技手段防范和杜绝顽固分子的骗保行为也是行业急需解决的问题。</p>
              <div class="item_img"><img src="../../assets/img/clientDetail/client1_big.jpg" alt=""></div>
              <div class="title">
                <i></i>解决方案
              </div>
              <p>杭州牛盾网络技术有限公司与都邦保险正式签约，联合打造业内首创的“物联网+保险”安全保险模式，为保险业内有溯源需求的险种量身打造了一款物联网辨识标签，并提供了全方位的解决方案，以快递工具险种为例。牛盾网络将多种辨识方式集于一张标签上，加强了标签的唯一性和安全性，确保“哪台出险报哪台”的车必须真实投保，堵住骗保漏洞，避免不必要的理赔损失。</p>
              <div class="title">
                <i></i>方案价值
              </div>
              <p>给三轮电动车一个“保险身份”，技术手段治理物流公司乱报现象，牛盾网络将多种辨识方式集于一张标签上，加强了标签的唯一性和安全性，确保“哪台出险报哪台”的车必须真实投保，堵住骗保漏洞，避免不必要的理赔损失。“物联网+保险”让续保更便利；数据可溯源，大数据助力保险数字化。</p>
            </div>
          </div>
        </div>
      </div>
      <!--footerBar-->
      <div class="gw_homefooterBox">
        <footerBar></footerBar>
      </div>
    </div>
</template>

<script>
    import navBar from '../../components/Navbar';
    import footerBar from '../../components/footerbar'
    export default {
      components:{
        navBar,footerBar
      },
      methods:{
        goBack(){
          this.$router.push('/client');
        },
        goProduct(url){
          this.$router.push(url);
          window.scrollTo({top:0});
        }
      }
    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/client/client1.vue